<template>
    <header>
        <img src="@/assets/mik_logo.svg" width="200px" alt="mik_logo">

    </header>
</template>

<script>
export default {

}</script>

<style>
@media(max-width:500px) {
    header {
        width: 100%;
        margin-top: 50px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
}
</style>